export default "__VITE_ASSET__EPaQ5ND9__"